import { useNavigate } from "react-router-dom";
import { East } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import AmountUtils from "../../Utils/AmountUtils";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const useStyles = makeStyles({
  agentOrderCard: {
    marginBottom: "10px",
    borderRadius: "10px",
    boxShadow: "0px 12px 24px 0px rgba(28, 28, 28, 0.10)",
  },
  orderBox: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 16px",
    borderBottom: "1px solid #eee",
  },
  boldSizeText: {
    fontSize: "14px",
    fontWeight: 700,
  },
  normalSizeText: {
    fontSize: "14px",
    fontWeight: 400,
  },
  alignElementVertically: {
    display: "flex",
    flexDirection: "column",
  },
  leadStatus: {
    borderRadius: "5px",
    padding: "5px 7px 5px 5px",
    fontSize: "12px",
    fontWeight: 400,
    display: "flex",
    alignItems: "center",
  },
  leadDetailsButton: {
    padding: "8px",
    fontSize: "12px",
    fontWeight: 700,
  },
});

export const fieldAgentOrderStatus = {
  UNFULFILLABLE: {
    value: "Unfulfillable",
    color: "#cc8800",
    background: "#FDF4E2",
  },
  FULFILLABLE: {
    value: "Fulfillable",
    color: "#00733E",
    background: "rgba(0, 115, 62, 0.2)",
  },
};

export default function FieldAgentOrderCard({ order, currentTab }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [orderType, setOrderType] = useState("");
  const MAX_CHARACTERS_FOR_DIST_AND_TALUKA = 10;

  const truncateDistAndTalukaName = (name) => {
    return name?.length > MAX_CHARACTERS_FOR_DIST_AND_TALUKA
      ? name.slice(0, MAX_CHARACTERS_FOR_DIST_AND_TALUKA).concat("...")
      : name;
  };

  const shouldShowConfirmOrderCTA = () => {
    return (
      currentTab === "onHold" &&
      order?.fulfillmentStatus === "FULFILLABLE" &&
      order?.placedById == localStorage.getItem("fieldAgentUserId")
    );
  };

  useEffect(() => {
    if (
      (order?.statusMessage?.toLowerCase() === "approval pending" ||
        order?.statusMessage?.toLowerCase() === "payment pending") &&
      currentTab === "pendingForApproval"
    ) {
      setOrderType("approvalPending");
    } else if (currentTab === "onHold") {
      if (order?.fulfillmentStatus === "UNFULFILLABLE") {
        setOrderType("onHold");
      } else if (
        order?.fulfillmentStatus === "FULFILLABLE" &&
        order?.placedById == localStorage.getItem("fieldAgentUserId")
      ) {
        setOrderType("fulfillable");
      } else {
        setOrderType("onHold");
      }
    }
  }, []);

  return (
    <Card
      className={classes.agentOrderCard}
      onClick={() =>
        navigate({
          pathname: `/orders/${order?.orderId}`,
          search: orderType ? `?type=${orderType}` : "",
        })
      }
    >
      <Grid
        className={classes.orderBox}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Grid
          item
          xs={10}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography className={classes.boldSizeText}>
            {order?.saathiName ? order?.saathiName : ""}
          </Typography>
          <Typography
            sx={{
              color:
                currentTab === "onHold"
                  ? fieldAgentOrderStatus[order?.fulfillmentStatus]?.color
                  : order?.statusColor
                    ? order.statusColor
                    : "",
              background:
                currentTab === "onHold"
                  ? fieldAgentOrderStatus[order?.fulfillmentStatus]?.background
                  : order?.statusContainerColor
                    ? order.statusContainerColor
                    : "",
              display: "flex",
              alignItems: "center",
              fontSize: "12px",
              padding: "8px",
              borderRadius: "8px",
              textTransform: "capitalize",
              whiteSpace: "nowrap",
              height: "fit-content",
            }}
          >
            {currentTab === "onHold"
              ? fieldAgentOrderStatus[order?.fulfillmentStatus]?.value
              : order?.statusMessage
                ? order.statusMessage
                : ""}
          </Typography>
        </Grid>
        <Grid
          item
          xs={3}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "3px",
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              whiteSpace: "nowrap",
            }}
          >
            <b>Dist: </b> {truncateDistAndTalukaName(order?.district)} |{" "}
            <b>Tal: </b> {truncateDistAndTalukaName(order?.taluka)}
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
            }}
          >
            {order?.createdOn ? order?.createdOn : ""}
          </Typography>
        </Grid>
      </Grid>
      <Grid className={classes.orderBox}>
        <Typography
          sx={{ display: "flex", alignItems: "center", fontSize: "13px" }}
        >
          Placed By: {order?.placedBy ? order?.placedBy : ""}
        </Typography>
      </Grid>
      <Box className={classes.orderBox}>
        <Box className={classes.alignElementVertically}>
          <Typography className={classes.normalSizeText} component="span">
            Order ID
          </Typography>
          <Typography className={classes.boldSizeText} component="span">
            {order?.orderId ? order?.orderId : ""}
          </Typography>
        </Box>
        <Box className={classes.alignElementVertically}>
          <Typography className={classes.normalSizeText} component="span">
            Total Amount
          </Typography>
          <Typography
            className={classes.boldSizeText}
            sx={{ textAlign: "right" }}
            component="span"
          >
            {AmountUtils.formatCurrency(order?.grandTotal)}
          </Typography>
        </Box>
      </Box>
      <Button
        fullWidth
        endIcon={<East />}
        className={classes.leadDetailsButton}
        sx={{
          color: shouldShowConfirmOrderCTA() ? "#00733E" : "#9D2123",
        }}
      >
        {shouldShowConfirmOrderCTA() ? "Confirm Order" : "Order Details"}
      </Button>
      {shouldShowConfirmOrderCTA() && (
        <Grid container alignItems={`center`} justifyContent={`flex-start`}>
          <Grid
            item
            xs={12}
            sx={{
              background: "#00733E40",
              paddingBottom: "4px",
              paddingTop: "4px",
              textAlign: "center",
            }}
          >
            <Typography
              variant={`body1`}
              sx={{
                color: "#00733E",
                fontSize: "12px",
                marginLeft: "4px",
              }}
            >
              Please confirm the order for further processing
            </Typography>
          </Grid>
        </Grid>
      )}
    </Card>
  );
}
